import React from 'react';
import PropTypes from 'prop-types';

// Lucide `trending-up` (ISC license) — https://lucide.dev/icons/trending-up
const TrendingUpIcon = ({ className = '', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M16 7h6v6" />
    <path d="m22 7-8.5 8.5-5-5L2 17" />
  </svg>
);

TrendingUpIcon.propTypes = {
  className: PropTypes.string,
};

export default TrendingUpIcon;
